import { ActionHint, Player, PlayerStates } from '@ppwr/poker'
import { CardString } from 'pokersolver'
import { DealTheFlopCards, DealTheFlopCommunityCards, DealTheFlopSteps } from './deal-the-flop'
import { RaiseOrFoldCards, RaiseOrFoldSteps } from './raise-or-fold'
import { TableTourCards, TableTourSteps } from './table-tour'

export const WalkthroughTypes = ['TableTour', 'RaiseOrFold', 'DealTheFlop'] as const
export type WalkthroughType = (typeof WalkthroughTypes)[number]

export type WalkthroughPlayersIds = 'bettina' | 'esther' | 'dianne' | 'jane' | 'tara'

const PlayerCards = {
  TableTour: TableTourCards,
  RaiseOrFold: RaiseOrFoldCards,
  DealTheFlop: DealTheFlopCards
} as const

const CommunityCards: Record<WalkthroughType, (step: number) => CardString[]> = {
  TableTour: () => ['5c', 'Ad', '8s'] as CardString[],
  RaiseOrFold: () => [],
  DealTheFlop: DealTheFlopCommunityCards
}

export const WalkthroughPlayers = (walkthroughType: WalkthroughType, step: number) => {
  const bettina = new Player('Bettina', 1000, 'bettina', [], undefined, undefined, 'bettina')
  bettina.actions = [ActionHint.RAISE, ActionHint.CALL, ActionHint.FOLD]
  const esther = new Player('Esther', 1000, 'esther', [], undefined, undefined, 'esther')
  esther.role = 'D'
  const dianne = new Player('Dianne', 1000, 'dianne', [], undefined, undefined, 'dianne')
  dianne.role = 'SB'
  const jane = new Player('Jane', 1000, 'jane', [], undefined, undefined, 'jane')
  jane.role = 'BB'
  const tara = new Player('Tara', 1000, 'tara', [], undefined, undefined, 'tara')
  tara.color = 'Brand/Orange'
  const players = [bettina, esther, dianne, jane, tara]

  const playerCards = PlayerCards[walkthroughType](step)

  return players.map((p) => {
    const pCards = playerCards[p.id as WalkthroughPlayersIds]
    if (pCards) {
      p.cards = pCards
    }
    p.state = PlayerStates.InPlay
    return p
  })
}

export const WalkthroughCommunityCards = (walkthroughType: WalkthroughType, step: number) => {
  return CommunityCards[walkthroughType](step)
}

export const Walkthroughs = {
  TableTour: TableTourSteps,
  RaiseOrFold: RaiseOrFoldSteps,
  DealTheFlop: DealTheFlopSteps
} as const
